import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import axios from '../../api/axios'
import DOMPurify from 'dompurify'

export default function Policy() {
   const [description, setDescription] = useState('')

   const getContents = async () => {
      try {
         await axios
            .post(`getContents`)
            .then((result) => {
               setDescription(DOMPurify.sanitize(result.data.privacy))
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   useEffect(() => {
      getContents()
   }, [])

   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: '#F3F6F9',
            overflowY: 'overlay',
         }}
      >
         <Box sx={{ mt: '80px' }}>
            <h2 style={{ color: '#163A5F', margin: '0px' }}>Privacy Policy</h2>
         </Box>
         <Box
            sx={{
               mt: '10px',
               borderTop: '5px solid #163A5F',
               bgcolor: 'white',
               borderBottomRightRadius: '5px',
               borderBottomLeftRadius: '5px',
               overflow: 'auto',
               p: '10px',
               height: '60vh',
            }}
            id='description'
            dangerouslySetInnerHTML={{ __html: description }}
         />
      </Box>
   )
}
